import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn';

/** Bloco de carregamento com o formato do conteúdo que vai chegar. */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return <div aria-hidden className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
